import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'
import type { UserLendPositionsOrderBy } from '@/hooks/positions/userLendPositionsQuery'

export const COLUMN_ID_TO_ORDER_BY: Record<string, UserLendPositionsOrderBy> = {
  lent: 'supplyAssetsUsd',
  netApy: 'netSupplyApy'
}

export const LEND_POSITIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: [
    {
      id: 'lent',
      desc: true
    }
  ],
  columnFilters: [],
  columnOrder: [],
  version: 1
}
export const LEND_POSITIONS_STORAGE_KEY = 'lendPositionsTable'
